import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function getAlertas(CodigoDealer, CorreoElectronico, linea, Region, Pagenumber) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarAlertas";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.Vkorg': linea.vkorg,
        'dto.Linea': linea.linea,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': CorreoElectronico,
        'dto.Pagenumber': Pagenumber,
        'dto.Pagesize': data.PageSizeAlerta,
        'dto.Region': Region,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}
export function getTopAlertas(dealer, linea, asociado) {

    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/ListarTopAlertas";
    params.data = {
        'dto.CodigoDealer': dealer.codcliente,
        'dto.DispositivoDealer': DispositivoId,
        'dto.CorreoElectronicoDealer': dealer.correoElectronico,
        'dto.Pagenumber': 1,
        'dto.Pagesize': data.PageSizeToAlerta,
        'dto.Region': asociado.poblacion,
        'dto.Vkorg': linea.vkorg,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}